import { httpClientBanking } from '~/domains/banking/shared/infra/http-client-banking'

export function createPersonalAccount() {
  return httpClientBanking<{ singUpRequestId: string }>({
    url: '/me/payment_account',
    method: 'POST'
  })
}
